<template>
  <div class="measurement-card" v-on:click="show(measurement)">
    <span class="measurement-result">{{ formatWeight(measurement.weight) }} kg</span>
    <span class="measurement-top float-right text-right">
      {{ formatDateTime(measurement) }}
      <span style="display: block" v-if="hasScale(measurement)">{{ getScaleFullInfo(measurement.scale_id) }}</span>
    </span>
    <span v-if="measurement.comment" class="measurement-comment">{{ measurement.comment }}</span>
  </div>
</template>

<script>
import { store } from "@/store.js";

export default {
  name: "WeightCard",
  props: {
    measurement: Object
  },
  data: function() {
    return { store: store };
  },
  methods: {
    initData: function() {},
    show: function(measurement) {
      this.$router.push({
        name: "weight.show",
        params: { id: measurement.id }
      });
    },
    formatWeight: function(rawWeight) {
      var number = parseInt(rawWeight) / 1000;
      return number
        .toFixed(1)
        .toString()
        .replace(".", ",");
    },

    getScaleFullInfo: function(scaleId) {
      if (scaleId == null) {
        return "-";
      }

      let scale = this.store.getScale(scaleId);

      if (scale == undefined) {
        return "-";
      }

      let fullInfo = scale.manufacturer + " " + scale.model;

      if (scale.comment)
        fullInfo = fullInfo + " (" + scale.comment + ")";

      return fullInfo;
    },
    formatRawDate: function(rawDate) {
      return this.moment(rawDate).format("D.M.YYYY");
    },
    formatRawDateTime: function(rawDate, rawTime) {
      return this.moment(rawDate + " " + rawTime).format("D.M.YYYY HH:mm");
    },
    formatDateTime: function(measurement) {
      if (measurement.time == null) {
        return this.formatRawDate(measurement.date);
      }

      return this.formatRawDateTime(measurement.date, measurement.time);
    },
    hasScale(measurement) {
      return measurement.scale_id != null && measurement.scale_id > 0;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.measurement-card {
  cursor: pointer;
  border-radius: 0.25rem;
  /* width: 18rem; */
  border: 1px solid rgba(0, 0, 0, 0.125);
  padding: 1rem;
  margin-bottom: 1rem;
}
.measurement-top {
  display: block;
  font-size: 80%;
  color: gray;
}

.measurement-result {
  font-weight: bold;
  font-size: 130%;
  clear: both;
  color: #222;
}

.measurement-comment {
  font-size: 90%;
  color: #111;
  display: block;
}
</style>
